export const package_list = [
  {
    key:"1",
    Plan_Name: "Basic",
    Plan_Type: "Monthly",
    Total_Subscribers: "56",
    Price: "$50",
    Created_Date: "14 Jan 2024",
    Status: "Active",
  },
  {
    key:"2",
    Plan_Name: "Advanced",
    Plan_Type: "Monthly",
    Total_Subscribers: "99",
    Price: "$200",
    Created_Date: "21 Jan 2024",
    Status: "Active",
  },
  {
    key:"3",
    Plan_Name: "Premium",
    Plan_Type: "Monthly",
    Total_Subscribers: "58",
    Price: "$300",
    Created_Date: "10 Feb 2024",
    Status: "Active",
  },
  {
    key:"4",
    Plan_Name: "Enterprise",
    Plan_Type: "Monthly",
    Total_Subscribers: "67",
    Price: "$400",
    Created_Date: "18 Feb 2024",
    Status: "Active",
  },
  {
    key:"5",
    Plan_Name: "Basic",
    Plan_Type: "Yearly",
    Total_Subscribers: "78",
    Price: "$600",
    Created_Date: "15 Mar 2024",
    Status: "Active",
  },
  {
    key:"6",
    Plan_Name: "Advanced",
    Plan_Type: "Yearly",
    Total_Subscribers: "99",
    Price: "$2400",
    Created_Date: "26 Mar 2024",
    Status: "Active",
  },
  {
    key:"7",
    Plan_Name: "Premium",
    Plan_Type: "Yearly",
    Total_Subscribers: "48",
    Price: "$3600",
    Created_Date: "05 Apr 2024",
    Status: "Active",
  },
  {
    key:"8",
    Plan_Name: "Enterprise",
    Plan_Type: "Yearly",
    Total_Subscribers: "17",
    Price: "$4800",
    Created_Date: "16 Apr 2024",
    Status: "Active",
  },
];
